export default {
    10001: 'Account is not active',
    10002: 'Trial account does not support this feature',
    10003: 'Incoming call rejected due to inactive account',
    11100: 'Invalid URL format',
    11200: 'HTTP retrieval failure',
    11205: 'HTTP connection failure',
    11206: 'HTTP protocol violation',
    11210: 'HTTP bad host name',
    11215: 'HTTP too many redirects',
    11220: 'SSL/TLS Handshake Error',
    11235: 'Certificate Invalid - Domain Mismatch',
    11236: 'Certificate Invalid - Certificate Expired',
    11237: 'Certificate Invalid - Could not find path to certificate',
    11251: 'Fatal protocol violation',
    11300: 'Invalid template URL',
    11310: 'Invalid template token',
    11320: 'Invalid template unclosed brackets',
    11750: 'TwiML response body too large',
    11751: 'MMS -> Media exceeds mobile operator size limit',
    11770: 'Empty response body',
    12100: 'Document parse failure',
    12101: 'Invalid Twilio Markup XML version',
    12102: 'The root element must be Response',
    12200: 'Schema validation warning',
    12300: 'Invalid Content-Type',
    12400: 'Internal Failure',
    13000: 'Conference Noun cannot be mixed with Number nouns',
    13110: 'Annotate: Annotate must contain one valid nested element',
    13111: 'Annotate: Annotate must contain only one of element X',
    13112: 'Annotate: Invalid nested element',
    13120: 'Annotate->BillingReferenceTag cannot be over 128 characters',
    13201: 'Dial: Cannot Dial out from a Dial Call Segment',
    13210: 'Dial: Invalid method value',
    13211: 'Dial: Invalid ifMachine value',
    13212: 'Dial: Invalid timeout value',
    13213: 'Dial: Invalid hangupOnStar value',
    13214: 'Dial: Invalid callerId value',
    13215: 'Dial: Invalid nested element',
    13216: 'Dial: Invalid timeLimit value',
    13217: 'Dial: Invalid record value',
    13221: 'Dial->Number: Invalid method value',
    13222: 'Dial->Number: Invalid sendDigits value',
    13223: 'Dial: Invalid phone number format',
    13224: 'Dial: Twilio does not support calling this number or the number is invalid',
    13225: 'Dial: Call blocked by Twilio blacklist',
    13226: 'Dial: Invalid country code',
    13227: 'Geo Permission configuration is not permitting call',
    13230: 'Dial->Conference: Invalid muted value',
    13231: 'Dial->Conference: Invalid endConferenceOnExit value',
    13232: 'Dial->Conference: Invalid startConferenceOnEnter value',
    13233: 'Dial->Conference: Invalid waitUrl',
    13234: 'Dial->Conference: Invalid waitMethod',
    13235: 'Dial->Conference: Invalid beep value',
    13236: 'Dial->Conference: Invalid Conference Sid',
    13237: 'Dial->Conference: Invalid Conference Name',
    13238: 'Dial->Conference: Invalid Verb used in waitUrl TwiML',
    13239: 'Dial->Conference: Invalid Trim Value',
    13240: 'Dial->Conference: Invalid Whisper SID',
    13241: 'Dial->SIP: Invalid method value',
    13242: 'Dial->SIP: Invalid sendDigits value',
    13243: 'Dial->SIP: Invalid SIP URI',
    13244: 'Dial: No SIP Authorization',
    13245: 'Dial: Not allowed in this API version',
    13246: 'Dial: SIP dialing not enabled for this account',
    13247: 'Dial: Invalid callerID, invalid characters',
    13248: 'Dial: Invalid callerID, too long',
    13249: 'Dial: Invalid username or password attribute',
    13250: 'Dial: Too many URIs passed',
    13251: 'Dial: Too many headers passed',
    13252: 'Dial: Invalid header name',
    13253: 'Dial: Header is too long',
    13254: 'Dial->Sip: SIP URI DNS does not resolve or resolves to an non-public IP address',
    13255: 'Dialing .sip.twilio.com addresses is not currently allowed',
    13299: '2010 Conference API feature requested using 2008 API',
    13310: 'Gather: Invalid finishOnKey value',
    13311: 'Gather: Invalid finishOnKey value',
    13312: 'Gather: Invalid method value',
    13313: 'Gather: Invalid timeout value',
    13314: 'Gather: Invalid numDigits value',
    13320: 'Gather: Invalid nested verb',
    13321: 'Gather->Say: Invalid voice value',
    13322: 'Gather->Say: Invalid loop value',
    13325: 'Gather->Play: Invalid Content-Type',
    13326: 'Gather: Invalid input value',
    13327: 'Gather: Invalid speechTimeout value',
    13328: 'Gather: Invalid maxSpeechTime value',
    13329: 'Gather: Invalid partialResultCallbackMethod value',
    13330: 'Gather: Invalid hints value',
    13331: 'Gather: Invalid language value',
    13332: 'Gather: Invalid bargeIn value',
    13410: 'Play: Invalid loop value',
    13420: 'Play: Invalid Content-Type',
    13510: 'Say: Invalid loop value',
    13511: 'Say: Invalid voice value',
    13512: 'Gather element has an invalid "lang" parameter',
    13520: 'Say: Invalid text',
    13521: 'Say element cannot exceed 4096 characters',
    13610: 'Record: Invalid method value',
    13611: 'Record: Invalid timeout value',
    13612: 'Record: Invalid maxLength value',
    13613: 'Record: Invalid finishOnKey value',
    13614: 'Record: Invalid transcribe value',
    13615: 'Record: maxLength too high for transcription',
    13616: 'Record: playBeep must be true or false',
    13617: 'Record: Recording length is out of range for transcription',
    13618: 'Record: Recording not available for transcription',
    13619: 'Record: Transcription feature not available for this type of recording.',
    13620: 'Record: Transcription not available for this recording',
    13621: 'Invalid "recordingStatusCallbackEvent"',
    13710: 'Redirect: Invalid method value',
    13910: 'Pause: Invalid length value',
    14101: 'Invalid "To" attribute',
    14102: 'Invalid "From" attribute',
    14103: 'Invalid Body',
    14104: 'Invalid Method attribute',
    14105: 'Invalid statusCallback attribute',
    14106: 'Document retrieval limit reached',
    14107: 'SMS send rate limit exceeded',
    14108: 'From phone number not SMS capable',
    14109: 'SMS Reply message limit exceeded',
    14110: 'Invalid Verb for SMS Reply',
    14111: 'Invalid To phone number for Trial mode',
    14201: 'Enqueue: Invalid method value',
    14202: 'Enqueue: Invalid waitUrl',
    14203: 'Enqueue: Invalid Enqueue action url',
    14204: 'Enqueue: Queue name too short',
    14205: 'Enqueue: Queue name too long',
    14206: 'Enqueue: Invalid waitUrlMethod value',
    14210: 'Dial->Queue: Invalid whisper method',
    14211: 'Dial->Queue: Invalid whisper url',
    14212: 'Dial->Queue: queue name too short',
    14213: 'Dial->Queue: queue name too long',
    14215: 'Dial->Queue: Invalid ReservationSid. Unable to dequeue',
    14217: 'Dial->Queue: Could not find or accept provided reservationSid',
    14220: 'Enqueue: Provided Workflow was not a valid sid',
    14221: 'Enqueue: Provided Attributes JSON was not valid',
    14222: 'Enqueue: Could not create Task',
    14223: 'Enqueue: Unable to cleanup task',
    14230: 'Dial->Conference: Invalid WorkflowSid',
    14231: 'Dial->Conference: Provided Attributes was not valid JSON',
    14232: 'Dial->Conference: Invalid Priority',
    14233: 'Dial->Conference: Invalid Timeout',
    14234: 'Dial->Conference: Unable to create task',
    14235: 'Dial->Conference: Unable to cleanup task',
    14236: 'Dial->Conference: Invalid ReservationSid',
    14237: 'Dial->Conference: Invalid PostWorkActivitySid',
    14238: 'Dial->Conference: Unable to accept Reservation',
    14239: 'Dial->Conference: Unable to update Worker',
    15000: 'Call Progress: Internal Twilio Error',
    15002: 'Call Progress: Queue Timeout',
    15003: 'Call Progress: Error Response to Callback URL',
    16000: 'Whisper Not Available on Twilio Conference',
    16104: 'Voice Recording: Unavailable due to encryption failure',
    16105: 'Voice Recording: Unavailable due to no valid public keys',
    16106: 'Voice Recording: Unavailable due to internal encryption error',
    16107: 'Voice Recording: Encrypted with alternate public key',
    16108: 'Voice Recording: Request failed due to concurrent recordings',
    20001: 'Unknown parameters',
    20002: 'Invalid FriendlyName',
    20003: 'Permission Denied',
    20004: 'Method not allowed',
    20005: 'Account not active',
    20006: 'Access Denied',
    20007: 'Page size too large',
    20008: 'Test Credentials',
    20009: 'Cannot delete this resource before it is complete',
    20010: 'Action disabled for account',
    20101: 'Invalid Access Token',
    20102: 'Invalid Access Token header',
    20103: 'Invalid Access Token issuer/subject',
    20104: 'Access Token expired or expiration date invalid',
    20105: 'Access Token not yet valid',
    20106: 'Invalid Access Token grants',
    20107: 'Invalid Access Token signature',
    20151: 'Authentication Failed',
    20152: 'Invalid Header',
    20153: 'Invalid Issuer Or Subject',
    20154: 'Invalid Claim Set',
    20155: 'Expiration Time In The Future',
    20156: 'Expired or Invalid Expiration in Token',
    20157: 'Expiration Time Exceeds Maximum Time Allowed',
    20159: 'Invalid Signature',
    20160: 'Invalid Token',
    20403: '403 Forbidden',
    20404: 'Not Found',
    20429: 'Too Many Requests',
    20500: 'Internal Server Error',
    20503: 'Service unavailable',
    21100: 'Accounts Resource',
    21101: 'Subaccounts cannot contain subaccounts',
    21102: 'Reached maximum number of Services',
    21200: 'Calls Resource',
    21201: 'No Called number specified',
    21202: 'Called number is a premium number',
    21203: 'International calling not enabled',
    21204: 'Call already initiated',
    21205: 'Invalid URL',
    21206: 'Invalid SendDigits',
    21207: 'Invalid IfMachine',
    21208: 'Invalid Timeout',
    21209: 'Invalid Method',
    21210: 'Caller phone number not verified',
    21211: 'Invalid Called Phone Number',
    21212: 'Invalid Caller Phone Number',
    21213: 'Caller phone number is required',
    21214: '"To" phone number cannot be reached',
    21215: 'Geo Permission configuration is not permitting call',
    21216: 'API: Call blocked by Twilio blacklist',
    21217: 'Phone number does not appear to be valid',
    21218: 'Invalid ApplicationSid',
    21219: '"To" phone number not verified',
    21220: 'Invalid call state',
    21221: 'Invalid SipAuthUsername. Must be fewer than 256 chars',
    21222: 'Invalid SipAuthUsername. Illegal chars',
    21223: 'Invalid SipAuthPassword. Must be fewer than 256 chars',
    21224: 'Invalid SipAuthPassword. Illegal chars',
    21225: 'SipAuthPassword is required when providing SipAuthUsername',
    21226: 'SIP calling not enabled for this account',
    21227: 'Headers portion of SIP URI must be fewer than 1024 chars',
    21228: 'Invalid SIP Header. Illegal chars in header name',
    21229: 'Invalid SIP Header. Illegal chars in header value',
    21230: 'Maximum Domains Reached',
    21231: 'Domain Validation Error',
    21232: 'Invalid Domain',
    21233: 'Domain still has subdomains',
    21244: 'Maximum Number of Trunks reached',
    21245: 'Trunk Validation Error',
    21247: 'Trunk Dependencies',
    21248: 'Trunk Domain already taken',
    21249: 'Maximum Origination URIs reached',
    21251: 'Trunking CPS change not allowed',
    21252: 'Invalid Region',
    21401: 'Invalid Phone Number',
    21402: 'Invalid Url',
    21403: 'Invalid Method',
    21404: 'Inbound Phone number not available to trial account',
    21405: 'Cannot set VoiceFallbackUrl without setting Url',
    21406: 'Cannot set SmsFallbackUrl without setting SmsUrl',
    21407: 'This Phone Number type does not support SMS',
    21408: 'Permission to send an SMS has not been enabled for the region indicated by the "To" number',
    21409: 'VoiceCallerIdLookup cannot be set for this phone number',
    21420: 'ApplicationSid is not accessible',
    21421: 'PhoneNumber is invalid',
    21422: 'PhoneNumber is not available',
    21449: 'Number already can be used for outgoing calls and messages',
    21450: 'Phone number already validated on your account',
    21451: 'Invalid area code',
    21452: 'No phone numbers found in area code',
    21453: 'Phone number already validated on another account',
    21454: 'Invalid CallDelay',
    21455: 'Invalid PlayUrl',
    21456: 'Invalid CallbackUrl',
    21457: 'AreaCode Parameter not Supported',
    21458: 'PhoneNumber Provisioning Type Mismatch',
    21470: 'Invalid AccountSid',
    21471: 'Account does not exist',
    21472: 'Account is not active',
    21473: 'AccountSid you are transferring to is not related to the originating owner of the phone number',
    21474: 'API User must be the parent account to transfer phone numbers.',
    21475: 'Unable to update Status, invalid Status.',
    21476: 'Unable to update Status for subaccount, parent account is suspended.',
    21477: 'Unable to update Status for parent accounts',
    21478: 'Unable to update Status for subaccount, subaccount has been suspended by Twilio',
    21479: 'Unable to update Status for subaccount, subaccount has been closed.',
    21480: 'Reached maximum number of subaccounts',
    21481: 'Invalid PageToken',
    21501: 'Resource not available',
    21502: 'Invalid callback url',
    21503: 'Invalid transcription type',
    21504: 'RecordingSid is required.',
    21601: 'Phone number is not a valid SMS-capable inbound phone number',
    21602: 'Message body is required',
    21603: 'The source "From" phone number is required to send an SMS',
    21604: 'The destination "To" phone number is required to send an SMS',
    21605: 'Maximum body length is 160 characters',
    21606: 'The "From" phone number provided is not a valid, SMS-capable inbound phone number for your account.',
    21607: 'The "From" phone number must be the sandbox phone number for trial accounts.',
    21608: 'The "To" phone number provided is not yet verified for this account.',
    21609: 'Invalid "StatusCallback"',
    21610: 'SMS cannot be sent to the "To" number because the customer has replied with STOP',
    21611: 'This "From" number has exceeded the maximum number of queued messages',
    21612: 'The "To" phone number is not currently reachable via SMS',
    21613: 'PhoneNumber Requires Certification',
    21614: '"To" number is not a valid mobile number',
    21615: 'Phone Number Requires a Local Address',
    21616: 'The "From" number matches multiple numbers for your account',
    21617: 'The concatenated message body exceeds the 1600 character limit',
    21618: 'The message body cannot be sent',
    21619: 'Unable to create record',
    21620: 'Invalid media URL(s)',
    21621: 'The "From" number has not been enabled for MMS',
    21622: 'MMS has not been enabled for your account',
    21623: 'Number of media files exceeds allowed limit',
    21624: 'Invalid validity period value',
    21625: 'Phone Number Requires a Local Address',
    21626: 'Invalid "StatusCallbackEvent"',
    21628: 'Address Validation Error',
    21629: 'Address Validation Error - Check Suggested Address',
    21650: 'Phone Number Requires a Verified Identity Document',
    21651: 'Document does not satisfy regulatory requirement',
    21701: 'The Messaging Service does not exist',
    21702: 'The Messaging Service is not available to send new messages',
    21703: 'The Messaging Service does not have a phone number available to send a message',
    21704: 'The Messaging Service contains no phone numbers',
    21705: 'The Messaging Service is invalid',
    22100: 'Reached Maximum Verification Attempts',
    22101: 'Invalid Hosted Number Order SIDs',
    22102: 'Invalid Phone Number',
    22103: 'Unsupported Iso Country',
    22104: 'Invalid Email Format',
    22105: 'Invalid URL format',
    22106: 'Invalid Method',
    22107: 'Unable to Update Authorization Document',
    22108: 'Invalid Application SID',
    22109: 'Invalid Address SID',
    22110: 'Phone Number Not Hostable',
    22111: 'Invalid Hosted Number Order Status',
    22112: 'Unable to Update Hosted Number Order Status',
    22113: 'Phone Verification Incorrect',
    22114: 'Unable to Verify Code',
    22115: 'Invalid Unique Name',
    22116: 'Invalid Friendly Name',
    22117: 'Invalid Extension',
    22118: 'Invalid Verification Document SID',
    22119: 'Invalid Capabilities',
    22120: 'Invalid Verification Type',
    22121: 'Unable to Transfer Hosted Number',
    22122: 'Invalid Authorization Document Status',
    22123: 'Unable to Initiate Verification Call',
    30001: 'Queue overflow',
    30002: 'Account suspended',
    30003: 'Unreachable destination handset',
    30004: 'Message blocked',
    30005: 'Unknown destination handset',
    30006: 'Landline or unreachable carrier',
    30007: 'Carrier violation. Your message was flagged as going against carrier guidelines',
    30008: 'Unknown error',
    30009: 'Missing inbound segment',
    30010: 'Message price exceeds max price',
    30011: 'Incoming MMS not supported by the receiving phone number in this region',
    31000: 'Generic error',
    31201: 'Twilio Client: Error occurred while accessing microphone',
    32001: 'SIP: Trunk CPS limit exceeded',
    32002: 'SIP: Dial failure - Twilio SIP Domain not found',
    32006: 'SIP: Too many hops',
    32007: 'SIP: Too many endpoints/bindings for the Address-of-record (AOR)',
    32008: 'SIP: Registration per second limit reached',
    32009: 'The user you tried to dial is not registered with the corresponding SIP Domain',
    32010: 'SIP: No valid Origination URIs configured on your Elastic SIP Trunk',
    32011: 'Error communicating with your SIP communications infrastructure',
    32012: 'SIP: Master account pooled Trunking CPS limit exceeded',
    32013: 'SIP: Master account SIP Interface CPS limit exceeded',
    32014: 'Call is terminated because of no audio received',
    32015: 'Call is terminated due to exceeding max call duration of 4 hours.',
    32016: 'PSTN PDD timeout',
    32100: 'SIP: Trial accounts can only call verified caller IDs',
    32101: 'SIP: Invalid phone number',
    32102: 'SIP: Bad SDP',
    32103: 'SIP: Empty body',
    32105: 'SIP: Invalid contact header',
    32106: 'SIP: Authentication Error',
    32200: 'SIP: Insufficient permissions',
    32201: 'SIP: Source IP address not in ACL',
    32202: 'SIP: Bad user credentials',
    32203: 'SIP: Call blocked by Twilio blacklist',
    32204: 'SIP: Invalid Caller ID on Trial account',
    32205: 'SIP Trunking: Geo Permission configuration is not permitting call',
    32207: 'SIP: Secure media not accepted',
    32208: 'SIP: Secure media required',
    32209: 'SIP: Secure transport required',
    32210: 'SIP: Register not supported',
    32212: 'SIP: Registration Authentication problem',
    32214: 'SIP: Invalid',
    32215: 'Dial failure calling a SIP Domain without specifying a region',
    32216: 'SIP: Address blacklisted',
    32218: 'SIP: Transfer not allowed',
    32301: 'Interconnect: Invalid Connection(TNX) SID',
    32302: 'Interconnect: Connection(TNX) SID not found',
    32303: 'Interconnect: Multiple SIP Dials with Interconnect Connection(TNX) SID',
    32304: 'Interconnect: Connection(TNX) SID is not Active',
    34002: 'Callee Busy',
    34003: 'Callee did not answer',
    34004: 'Error during fax transmission',
    34106: 'No Fax TwiML action specified',
    34108: 'Other End Incompatible',
    40000: 'Content - Type of "application/json" not set',
    40100: 'TaskRouter->Reject',
    40110: 'TaskRouter->Call',
    40111: 'TaskRouter->Call',
    40112: 'TaskRouter->Call',
    40113: 'TaskRouter->Call',
    40114: 'TaskRouter->Call',
    40120: 'TaskRouter->Direct',
    40121: 'TaskRouter->Direct',
    40122: 'TaskRouter->Direct',
    40123: 'TaskRouter->Redirect',
    40130: 'TaskRouter->Dequeue',
    40131: 'TaskRouter->Dequeue',
    40132: 'TaskRouter->Dequeue',
    40133: 'TaskRouter->Dequeue',
    40134: 'Dequeue Instruction does not have a valid "status_callback_events" parameter',
    40135: 'TaskRouter->Dequeue',
    40140: 'TaskRouter->Conference',
    40141: 'TaskRouter->Conference',
    40142: 'TaskRouter->Conference',
    40143: 'TaskRouter->Conference',
    40144: 'TaskRouter->Conference',
    40145: 'TaskRouter->Conference',
    50000: 'Programmable Chat: FriendlyName not provided',
    50001: 'Programmable Chat: Account SID not provided',
    50002: 'Programmable Chat: Resource is being deleted',
    50050: 'Programmable Chat: Service Instance not found',
    50051: 'Programmable Chat: Service SID not provided',
    50052: 'Programmable Chat: Invalid consumption interval format',
    50053: 'Programmable Chat: Invalid typing indicator format',
    50054: 'Programmable Chat: Invalid webhook format',
    50055: 'Programmable Chat: Invalid webhook method',
    50056: 'Programmable Chat: Webhook disabled processing of command',
    50057: 'Programmable Chat: Webhook call failed to execute successfully',
    50058: 'Programmable Chat: Notification template too long',
    50059: 'Programmable Chat: Notification sound name too long',
    50060: 'Programmable Chat: Invalid user channels limit format',
    50061: 'Programmable Chat: Invalid channel members limit format',
    50063: 'Programmable Chat: Actions per second limit exceeded',
    50065: 'Programmable Chat: Invalid webhook retry count',
    50100: 'Programmable Chat: Role not found',
    50101: 'Programmable Chat: Channel role not found',
    50102: 'Programmable Chat: Deployment role not found',
    50103: 'Programmable Chat: Role SID not provided',
    50104: 'Programmable Chat: Permission not found',
    50105: 'Programmable Chat: Invalid role type',
    50106: 'Programmable Chat: Channel creator role not found',
    50107: 'Programmable Chat: User not authorized for command',
    50200: 'Programmable Chat: User not found',
    50201: 'Programmable Chat: User already exists',
    50202: 'Programmable Chat: User SID not provided',
    50203: 'Programmable Chat: Identity reserved',
    50204: 'Programmable Chat: Identity not provided',
    50205: 'Programmable Chat: User unauthorized to set role',
    50206: 'Programmable Chat: Identity should not match user SID pattern',
    50207: 'Programmable Chat: Identity too long',
    50208: 'Programmable Chat: User channel limit exceeded',
    50209: 'Programmable Chat: Invalid binding type',
    50300: 'Programmable Chat: Channel not found',
    50301: 'Programmable Chat: Channel key not provided',
    50302: 'Programmable Chat: Unknown channel command',
    50303: 'Programmable Chat: Attributes too long',
    50304: 'Programmable Chat: Attributes not valid JSON',
    50305: 'Programmable Chat: Channel SID not provided',
    50306: 'Programmable Chat: Unique name should not match channel SID pattern',
    50307: 'Programmable Chat: Channel with provided unique name already exists',
    50308: 'Programmable Chat: Invalid Date Created parameter',
    50309: 'Programmable Chat: Invalid Date Uodated parameter',
    50310: 'Programmable Chat: Author parameter is too long',
    50400: 'Programmable Chat: User not member of channel',
    50401: 'Programmable Chat: Member SID not provided',
    50402: 'Programmable Chat: Member not found',
    50403: 'Programmable Chat: Channel member limit exceeded',
    50404: 'Programmable Chat: Member already exists',
    50405: 'Programmable Chat: Invalid last consumption timestamp format',
    50406: 'Programmable Chat: Invalid last consumed message index format',
    50500: 'Programmable Chat: Message not found',
    50501: 'Programmable Chat: Message SID not provided',
    50502: 'Programmable Chat: Message index not provided',
    50503: 'Programmable Chat: Message body not provided',
    50504: 'Programmable Chat: Message body parameter is too long',
    50505: 'Programmable Chat: Last Updated By parameter is too long',
    50506: 'Programmable Chat: Media SID not provided',
    50507: 'Programmable Chat: Media not found',
    50508: 'Programmable Chat: Media already sent with another message',
    50509: 'Programmable Chat: Media message body cannot be updated',
    50600: 'Programmable Chat: Invite SID not provided',
    50601: 'Programmable Chat: Invite not found',
    51001: 'Client Connection: Connections resource limit exceeded',
    51002: 'Client Connection: Request rate limit exceeded',
    51003: 'Client Connection: identity too long',
    51004: 'Client Connection: endpoint_id too long',
    51005: 'Client Connection: Command or keepalive acknowledgement not received',
    51006: 'Client Connection: Connection expired',
    51007: 'Client Connection: Token authentication is rejected',
    52000: 'Internal notification error',
    52001: 'Invalid destination binding',
    52002: 'Invalid Credential Sid',
    52003: 'Invalid Credential Type',
    52004: 'Credential SID not specified',
    52051: 'Internal error when sending notification via client connection',
    52052: 'Client connection not created or closed',
    52071: 'Internal error when sending notification via mqtt client connection',
    52072: 'Client mqtt connection not created or closed',
    52101: 'Invalid GCM Api Key or FCM Secret',
    52102: 'Invalid GCM / FCM registration token',
    52103: 'GCM / FCM client uninstalled or turned off notifications',
    52104: 'Mismatched GCM / FCM sender ID',
    52105: 'Invalid GCM / FCM package name',
    52106: 'Notification too large for GCM / FCM',
    52107: 'Invalid custom key for GCM / FCM',
    52108: 'GCM / FCM device message rate exceeded',
    52109: 'GCM / FCM unauthorized error',
    52110: 'GCM / FCM service unavailable',
    52111: 'GCM / FCM unknown error',
    52131: 'Invalid APNs credentials',
    52133: 'Invalid APNs device token size',
    52134: 'Invalid APNs device token',
    52135: 'Missing subject in APNs certificate',
    52136: 'Missing payload for APNs delivery',
    52137: 'Invalid size of subject in APNs certificate',
    52138: 'APNs payload too large',
    52139: 'APN service shutdown',
    52140: 'Unknown APNs error',
    52141: 'The provided APNs device token has been unregistered',
    52142: 'The provided APNs device token is not correct',
    52143: 'The push notification was rejected by APNs',
    52144: 'APNs experienced an internal error',
    52145: 'Failed to authenticate with APNs',
    52147: 'Too many APNs provider token updates',
    52148: 'Expired APNs provider token used',
    52149: 'Invalid APNs provider token used',
    52161: 'Empty Credentials',
    52162: 'Credentials do not belong to used account',
    52163: 'Incorrect URL used to retrieve Webhook Credentials',
    52164: 'No Credentials found for the supplied Binding Type',
    52165: 'No Credentials found for the supplied Identifier',
    52166: 'Webhook Credentials endpoint responded with Internal Error',
    52167: 'Invalid Webhook Credentials response',
    52168: 'Webhook Credentials request timed out',
    52170: 'Too many Webhook Credential requests',
    52171: 'Webhook Credentials request signature was not verified',
    52172: 'Unexpected Binding Type used for Webhook Credentials request',
    52173: 'Unexpected Identifier used for Webhook Credentials request',
    52174: 'Unexpected "response received for Webhook Credentials request"',
    52181: 'Too many SMS notification requests',
    52182: 'Messaging Service not specified',
    52201: 'Too many Facebook messenger notification requests',
    52202: 'Facebook page is not connected to Twilio',
    52203: 'Missing body for Facebook Messenger delivery attempt',
    52211: 'Too many Alexa notifications',
    52212: 'Missing Alexa skill ID',
    52213: 'Invalid Alexa user ID',
    52214: 'Alexa skill is not connected to Twilio',
    52215: 'Missing Title parameter for Alexa',
    52301: 'Resulted destination list for requested parameters is empty',
    52302: 'Too many recipients',
    52303: 'Concurrent User update',
    52304: 'User already exists',
    52305: 'User already belongs to the segment',
    52306: 'Cannot delete User resource with Bindings',
    52307: 'No users with provided segments',
    52309: 'Channel provider replied with an error',
    52401: 'Too many notification log events',
    53000: 'Signaling connection error',
    53001: 'Signaling connection disconnected',
    53002: 'Signaling connection timed out',
    53003: 'Client received an invalid signaling message',
    53004: 'Client sent an invalid signaling message',
    53100: 'Room name is invalid',
    53101: 'Room name is too long',
    53102: 'Room name contains invalid characters',
    53103: 'Unable to create Room',
    53104: 'Unable to connect to Room',
    53105: 'Room contains too many Participants',
    53106: 'Room not found',
    53107: 'MaxParticipants is out of range',
    53108: 'RoomType is not valid',
    53109: 'Timeout is out of range',
    53110: 'StatusCallbackMethod is invalid',
    53111: 'StatusCallback is invalid',
    53112: 'Status is invalid',
    53113: 'Room creation failed',
    53200: 'Participant identity is invalid',
    53201: 'Participant identity is too long',
    53202: 'Participant identity contains invalid characters',
    53203: 'Participant has too many Tracks',
    53204: 'Participant not found',
    53205: 'Participant disconnected because of duplicate identity',
    53300: 'Track is invalid',
    53301: 'Track name is invalid',
    53302: 'Track name is too long',
    53303: 'Track name contains invalid characters',
    53304: 'Track name is duplicated',
    53400: 'Client is unable to create or apply a local media description',
    53402: 'Client is unable to apply a remote media description',
    53500: 'Unable to acquire configuration',
    53501: 'Unable to acquire TURN credentials',
    53600: 'S3 URL for recording upload is invalid',
    53601: 'AWS credentials for recording upload are invalid',
    53602: 'AWS encryption key for recording upload is invalid',
    53603: 'Internal failure while processing a recording',
    53604: 'Failed to upload the recording to S3',
    53605: 'Internal failure when retrieving your account\'s recording settings',
    53606: 'Internal failure when creating the recording resource',
    53607: 'Internal failure when updating the recording resource',
    53610: 'Invalid URL for external S3 bucket in recording settings',
    53611: 'Invalid AWS credentials to access external S3 bucket in recording settings',
    53612: 'Invalid public key for media tracks encryption in recording settings',
    53613: 'AWS credentials to access external S3 bucket could not be loaded',
    53614: 'Public key credentials for media tracks encryption could not be loaded',
    53615: 'Access denied to external S3 bucket configured in recording settings',
    53620: 'Invalid URL for external S3 bucket in composition settings',
    53621: 'Invalid AWS credentials to access external S3 bucket in composition settings',
    53622: 'Invalid public key for media tracks encryption in composition settings',
    53623: 'AWS credentials to access external S3 bucket could not be loaded',
    53624: 'Public key credentials for media tracks encryption could not be loaded',
    53625: 'Access denied to external S3 bucket configured in composition settings',
    53626: 'Internal failure while processing media composition',
    53627: 'Internal failure when updating the composition resource',
    53628: 'Room recordings deleted',
    53660: 'Status Callback response timed out',
    53661: 'StatusCallbackMethod is invalid',
    53662: 'StatusCallback is invalid',
    54003: 'Invalid If-Match header',
    54006: 'Request entity too large',
    54007: 'Access forbidden for identity',
    54008: 'Invalid JSON',
    54009: 'Rate limit exceeded',
    54050: 'Service Instance not found',
    54051: 'Invalid webhook URL',
    54053: 'Invalid friendly name',
    54056: 'Account cannot access requested Service Instance',
    54100: 'Document not found',
    54101: 'Invalid Document data',
    54103: 'Document revision mismatch',
    54150: 'List not found',
    54151: 'List Item not found',
    54155: 'List Item revision mismatch',
    54156: 'Invalid List Item data',
    54200: 'Map not found',
    54201: 'Map Item not found',
    54205: 'Map Item revision mismatch',
    54206: 'Invalid Map Item data',
    54208: 'Map Item already exists',
    54209: 'Invalid Map Item key',
    54250: 'Message Stream not found',
    54251: 'Invalid Message Stream Message data',
    54300: 'Unique name not found',
    54301: 'Unique name already exists',
    54302: 'Invalid unique name',
    54351: 'Invalid identity',
    54354: 'Permission not found',
    54450: 'Invalid "Direction" query parameter',
    54451: 'Invalid "Order" query parameter',
    54452: 'Invalid "Bounds"" query parameter',
    54453: 'Invalid "PageToken" query parameter',
    54454: 'Invalid "PageSize" query parameter',
    54458: 'Invalid List Item index',
    60101: 'Canadian number. Further authorization required.',
    60200: 'Phone Verification: Invalid parameter',
    60201: 'Phone Verification: Invalid verification code',
    60600: 'Unprovisioned or Out of Coverage',
    60601: 'Canadian number. Further authorization required.',
    61000: 'Add-ons: Internal server error',
    61001: 'Add-ons: Request timed out',
    61002: 'Add-ons: Provider could not complete request',
    61003: 'Add-ons: Requirements to invoke AddOns have not been met',
    61004: 'Add-ons: No results',
    61005: 'Add-ons: Bad request',
    61006: 'Add-ons: Add-ons unavailable for GET callbacks',
    61007: 'Add-ons: Response body too large',
    61008: 'Add-ons: HTTP too many redirects',
    61009: 'Add-ons: Could not fulfill request with available data',
    62000: 'Failed to write to the database.',
    62001: 'Invalid SID',
    62002: 'Exchange not found',
    62003: 'MPLS carrier not found.',
    62004: 'Direct connect not found.',
    62005: 'Bandwidth reserve not found.',
    62006: 'MPLS carrier is not associated with the exchange.',
    62007: 'Direct connect is not associated with the exchange.',
    62008: 'Bandwidth reserve is not associated with the exchange.',
    62009: 'Account SID was not found.',
    62010: 'No authentication was provided.',
    62011: 'Unauthorized',
    62012: 'Connection not found.',
    62013: 'Unable to identify account owner of connection.',
    62014: 'Connection not ready',
    62015: 'Connection in transition',
    62016: 'Connection not active',
    62017: 'No IP route specified',
    62018: 'Invalid IP route',
    62019: 'IP route exceeds permitted IP range',
    62020: 'Connection pending deletion.',
    62021: 'IP Gateway Invalid',
    62022: 'Missing account SID',
    62023: 'Missing exchange',
    62024: 'Missing connection type',
    62025: 'Interconnect: Invalid connection type',
    62026: 'Interconnect: Missing MPLS carrier SID',
    62027: 'Interconnect: Extra MPLS parameter',
    62028: 'Interconnect: Connection expired.',
    62034: 'Interconnect: No useful parameters provided.',
    62035: 'Interconnect: No bandwidth was specified in the request',
    62052: 'Interconnect: This account is not a subaccount of the Interconnect Connection owner\'s account.',
    62053: 'Interconnect: The subaccount is not authorized to access this connection.',
    63001: 'Channel could not authenticate the request.Please see Channel specific error message for more information',
    63002: 'Channel could not find the From address',
    63003: 'Channel could not find To address',
    63005: 'Channel did not accept given content.Please see Channel specific error message for more information',
    63006: 'Could not format given content for the channel.Please see Channel specific error message for more information',
    63007: 'Twilio could not find a Channel with the specified From address',
    63008: 'Could not execute the request because the channel module has been misconfigured.Please check the Channel configuration in Twilio',
    63009: 'Channel provider returned an internal service error(HTTP 5xx). Please see Channel specific error message for more information',
    63010: 'Twilio\'s platform encountered an internal error processing this message',
    63012: 'Channel provider returned an internal service error',
    63013: 'Channel policy violation',
    63014: 'Channel message blocked by user action',
    63015: 'Channel sandbox can only send messages to verified caller ids',
    70001: 'Validation Failed',
    70002: 'Bad request',
    70003: 'Outdated Entity',
    70004: 'Unauthorized',
    70005: 'Failure Threshold Exceeded',
    70051: 'Authorization Failed',
    70052: 'Public Key Client Validation Required For Account',
    70053: 'Public Key Client Validation Not Enabled For Account',
    70101: 'Unsupported Public Key Algorithm',
    70102: 'Unsupported Public Key Length',
    70103: 'Unsupported Public Key Exponent',
    70104: 'Invalid Public Key',
    70105: 'Invalid Type Specified in the Request',
    70106: 'Invalid AWS credentials',
    70151: 'Maximum Number Of API Keys Exceeded',
    70152: 'Request Contains Invalid Flags',
    70153: 'Public Key Specified Does Not Exist',
    70154: 'Public Key Is Invalid',
    70155: 'Request Is Missing Required HTTP Headers',
    70156: 'Request Hash Is Invalid',
    80101: 'Number Already Added To Other Service',
    80102: 'Participant Already In Interaction',
    80103: 'Participant Already In Session',
    80104: 'Phone Number Already In Service',
    80105: 'Short Code Already In Service',
    80201: 'No Available Voice Proxy',
    80202: 'No Available Message Proxy',
    80203: 'No Available Proxy For Country',
    80205: 'No Proxies For Service',
    80206: 'No Available Proxy',
    80301: 'Not Found Phone Number Sid',
    80303: 'Not Found Short Code Sid',
    80401: 'Account Sid Invalid',
    80402: 'Identifier Proxy Pair Invalid',
    80403: 'Interaction Sid Invalid',
    80404: 'Participant Identifier Invalid',
    80405: 'Participant Sid Invalid',
    80406: 'Phone Number Did Invalid',
    80407: 'Phone Number Sid Invalid',
    80408: 'Service Sid Invalid',
    80409: 'Session Sid Invalid',
    80503: 'No Records Updated',
    80601: 'Phone Number Not Available',
    80602: 'Non Unique Service Name',
    80603: 'Non Unique Session Name',
    80604: 'Proxy Identifier In Use',
    80605: 'Proxy Identifier Not In Service',
    80606: 'Proxy Identifier Not Owned By Account',
    80607: 'Session Closed',
    80608: 'Session Status Invalid',
    80609: 'Too Many Added Participants',
    80610: 'Unauthorized Operation',
    80611: 'Proxy Number In Active Sessions',
    80612: 'Duplicate Entry',
    80613: 'Downstream Request Rejected',
    80614: 'No Partner Participant Found',
    80701: 'Parameter Validation Failed',
    80901: 'Message Matched Stop Word',
    80902: 'No Active Session',
    80903: 'Unknown Participant',
    80904: 'Expired Session',
    80905: 'Unknown Scenario',
    80906: 'Interaction Not Open',
    80907: 'Open Interaction Not Found',
    80908: 'Callback Error',
    80909: 'Inbound Contact Rejected',
    80910: 'Message To Voice Only Session Rejected',
    80911: 'Call To Message Only Session Rejected',
    81000: 'The Execution has exceeded max steps allowed for a flow',
    81001: 'The Widget has exceeded max steps in a loop',
    81002: 'Unexpected event while processing Widget',
    81004: 'Failed to add member to Chat Channel',
    81005: 'Failed to transition because no match was found',
    81006: 'Failed to create Chat Channel',
    81007: 'Connecting to a Call timed out',
    81008: 'Failed to connect to outgoing Call',
    81009: 'Timed out enqueueing Call',
    81010: 'There was an internal error while processing a Function',
    81011: 'Failed to send Message',
    81012: 'Failed to update Sync service',
    81013: 'Failed to invoke Understand API',
    81014: 'There was an internal error while processing an HTTP request',
    90010: 'Account is not active',
};
